import React from 'react';
import './Spinner.css';

export interface SpinnerProps {
  /** Size: 'small' (16px), 'medium' (24px), 'large' (32px) */
  size?: 'small' | 'medium' | 'large';
  /** Color - uses currentColor by default to inherit from parent */
  color?: string;
  /** Custom CSS classes */
  className?: string;
  /** Inline styles */
  style?: React.CSSProperties;
  /** Accessible label - when provided, announced to screen readers; when omitted, treated as decorative */
  'aria-label'?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  color,
  className = '',
  style,
  'aria-label': ariaLabel,
}) => {
  const classes = ['hi-ui-spinner', `hi-ui-spinner--${size}`, className].filter(Boolean).join(' ');

  const combinedStyle: React.CSSProperties = {
    ...(color ? ({ '--hi-spinner-color': color } as React.CSSProperties) : {}),
    ...style,
  };

  // Decorative spinner (no label) - hidden from screen readers
  if (!ariaLabel) {
    return (
      <span className={classes} style={combinedStyle} aria-hidden="true" data-testid="spinner" />
    );
  }

  // Meaningful spinner (with label) - announced to screen readers
  return (
    <span
      className={classes}
      style={combinedStyle}
      role="status"
      aria-label={ariaLabel}
      data-testid="spinner"
    />
  );
};
